export const getTeamApplicationOverview = {
					variable: '$condition: TeamApplicationOverviewCondition!',
					query: `
  getTeamApplicationOverview(condition: $condition) {
    total
    records {
        serviceID
        serviceName
        totalAlerts
        apdex
        cpm
        load
        error
        respTime
        cpu
        ram
        storage
        network,
        errorCount,
        totalUserImpacted,
        totalCrashes,
        subType,
        availability,
        isCorrelationAvailable,
        correlatedCapability
    }
  }`
				};

export const getServiceInstancesOverview = {
  variable: "$condition: TeamApplicationOverviewCondition!",
  query: `
  getServiceInstancesOverview(condition: $condition) {
    total
    records {
      instanceId
      instanceName
      cpu
      ram
      storage
      network
      type
      availability
    }
  }`,
};

export const getTeamEndpointOverview = {
  variable: "$condition: TeamEndpointOverviewCondition!",
  query: `
  getTeamEndpointOverview(condition: $condition) {
    total
    records {
    endPointName
    endPointID
    respTime
    cpm
    error
    }
  }`,
};

export const getTeamAlarm = {
  variable: "$duration: Duration!,$serviceReq: ServiceReq!",
  query: `
  getAlarmForTeam(duration: $duration, serviceReq: $serviceReq) {
    msgs:msgs {
    alarmMessage
    docCount
    latest
    serviceId
    serviceName
    },
  }`,
};

export const getAppsByCap = {
  variable: "$serviceReq: ServiceReq!",
  query: `query ($serviceReq: ServiceReq!){
    getApplicationOverview(serviceReq: $serviceReq) {
            capabilityAppCountList {
                count,
                type
            }
        }   
 }`,
};

export const getUsersImpacted = {
  variable: "$duration: Duration!",
  query: `query ($duration: Duration!,$condition: HomePageCondition){
    userImpacted(duration: $duration,condition: $condition) {
       userImpacted {
               capability,
              values {
                  values{
                      values{
                          value
                      }
                  }
              }
          }
      }
  }`,
};

export const topAppsByAlert = {
  variable: "$duration: Duration!,$condition: TopAlertingCondition",
  query: `query ($duration: Duration!,$condition: TopAlertingCondition){
    topApps(duration: $duration,condition: $condition) {
      alertsApps {
              serviceName,
              count,
              serviceId,
              capability
         }
     }
 
}`,
};

export const topAlertsByCap = {
  variable: "duration: $duration,condition: $condition",
  query: `query ($duration: Duration!,$condition: TopAlertingCondition){
    
    topAlertsByCapability(duration: $duration,condition: $condition) {
         alertCount {
                 capability,
                 alerts
            }
        }
    
 }`,
};

export const apdexScores = {
  variable: "$duration: Duration!,$condition: MetricsCondition",
  query: `query ($duration: Duration!,$condition: MetricsCondition){
    
    apdex(duration: $duration,condition: $condition) {
         apdexes {
                 scoreType,
                 percentage
            }
        }
    
 }`,
};

export const topAppsByRespTime={
variable:`$duration: Duration!,$condition: HomePageCondition`,
query:`query ($duration: Duration!,$condition: HomePageCondition){
    
  getTopAppByRespTime(duration: $duration,condition: $condition) {
       response {
               serviceId
               serviceName
               capability
               values {
                avg,
                   values {
                      values {
                          value
                      } 
                   }
               }
          }
      }
  
}`
}
export const notificationStatus = {
  variable: {},
  query: `query getNotification{    
    response: getNotification{
      notificationId, 
      startTime,
      endTime,
      message,
      type
    }
    }`,
};

export const getSummaryMetric = {
  variable: `$condition: SummaryMetricCondition!, $duration: Duration!, $valueColumn: String`,
  query: `dashboardSummary(condition: $condition, duration: $duration, valueColumn: $valueColumn) {
    metricsValue{
        metricName,
        value
    }
  }`,
};


export const metricRate = {
  variable: `$condition: MetricsCondition!, $duration: Duration!, $keyword: String`,
  query: `readMetricsPercentage: readMetricsPercentage(condition: $condition, duration: $duration, keyword: $keyword) {
    label
    value
  }`,
};

export const getApdexAppList = {
  variable: `$condition: TeamApplicationOverviewCondition!`,
  query: `getTeamApplicationOverview(condition: $condition) {
    total
    records {
        serviceID
        serviceName
        apdex
        respTime
    }
  }`,
};
